import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { useLang } from "@/lib/i18n";
import { TICKET_SHOP_URL } from "@/lib/media";

const TARGET = new Date("2026-11-20T17:30:00+01:00").getTime();

function useCountdown() {
  const calc = () => {
    const diff = Math.max(0, TARGET - Date.now());
    return {
      d: Math.floor(diff / 86400000),
      h: Math.floor((diff % 86400000) / 3600000),
      m: Math.floor((diff % 3600000) / 60000),
      s: Math.floor((diff % 60000) / 1000),
    };
  };
  const [t, setT] = useState(calc);
  useEffect(() => {
    const id = setInterval(() => setT(calc()), 1000);
    return () => clearInterval(id);
  }, []);
  return t;
}

export default function Countdown() {
  const { t } = useLang();
  const time = useCountdown();
  const cells = [
    { v: time.d, l: t("cd_days") },
    { v: time.h, l: t("cd_hours") },
    { v: time.m, l: t("cd_min") },
    { v: time.s, l: t("cd_sec") },
  ];
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 2.5, duration: 0.9 }}
      className="mt-10 mb-16 md:mb-24"
    >
      <a href={TICKET_SHOP_URL} target="_blank" rel="noopener noreferrer" data-testid="countdown" className="group inline-block">
        <p className="font-cinzel text-[10px] md:text-xs tracking-[0.35em] uppercase text-hell-gold mb-3 text-center group-hover:text-hell-ember transition-colors">
          {t("cd_label")}
        </p>
        <div className="flex gap-3 md:gap-4">
          {cells.map((c) => (
            <div key={c.l} className="text-center border border-white/15 bg-black/40 backdrop-blur px-3 md:px-5 py-3 min-w-[64px] md:min-w-[84px] group-hover:border-hell-gold/50 transition-colors">
              <span data-testid={`countdown-${c.l}`} className="font-display text-3xl md:text-5xl text-hell-bone tabular-nums leading-none">
                {String(c.v).padStart(2, "0")}
              </span>
              <span className="block font-cinzel text-[9px] md:text-[10px] tracking-[0.25em] uppercase text-hell-bone/50 mt-1.5">
                {c.l}
              </span>
            </div>
          ))}
        </div>
      </a>
    </motion.div>
  );
}
